module.exports = __webpack_public_path__ + "img/roles-empty-state.242a17fc.svg";